<template>
  <div class="share">
    <div class="caption">このサイトをシェアする</div>
    <a :href="`https://twitter.com/share?url=${url}&text=${title}`" rel="nofollow" target="_blank">
      <i class="fab fa-twitter-square fa-2x twitter"></i>
    </a>
    <a :href="`http://www.facebook.com/share.php?u=${url}`" rel="nofollow" target="_blank">
      <i class="fab fa-facebook-square fa-2x facebook"></i>
    </a>
    <a :href="`https://social-plugins.line.me/lineit/share?url=(${encodeURIComponent(url)})`" rel="nofollow" target="_blank">
      <i class="fab fa-line fa-2x line"></i>
    </a>
  </div>
</template>
<script>
export default {
  name: 'ShareButton',
  data () {
    return {
      url : "https://daredemo-youtube.com",
      title : "だれでも急上昇"
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShareButton.vue